export const STORAGE_KEYS = {
  users: "mock_users",
  posts: "mock_posts",
  likes: "mock_likes",
  comments: "mock_comments",
  commentsLikes: "mock_comments_likes",
  bookmarks: "mock_bookmarks",
};
